import {Component, ViewChild} from '@angular/core';
import {FileUpload} from "primeng/fileupload";
import {BankPluginConfig} from "../../../models/bank-plugin-config";
import {BankPluginConfigService} from "../../../services/bank-plugin-config.service";
import {FinancesService} from "../../../services/finances.service";
import {NgxSpinnerService} from "ngx-spinner";
import {MessageUtil} from "../../../utils/message.util";
import {TipoFormaPagamento} from "../../../models/finance/tipo-forma-pagamento";

@Component({
  selector: 'app-itau-bank',
  templateUrl: './itau-bank.component.html',
  styleUrls: ['./itau-bank.component.scss']
})
export class ItauBankComponent {
  @ViewChild('uploadCrt', { static: false }) uploadCrt!: FileUpload;
  @ViewChild('uploadKey', { static: false }) uploadKey!: FileUpload;

  interIntegrationConfig = new BankPluginConfig('ITAU_PLUGIN');
  paymentMethods: any[];
  paymentMethodsDropdown: any[];
  accounts: any[];
  accountDropdown: any[];
  billingPortifolioDropdown: any[];
  crtPath = false;
  keyPath = false;
  crtPreview: any;
  keyPreview: any;
  ITAU_BANK_CODE = 341;

  constructor(
      private bankPluginConfigService: BankPluginConfigService,
      private financesService: FinancesService,
      private spinner: NgxSpinnerService,
      private messageUtil: MessageUtil
  ) {}

  async ngOnInit(): Promise<void> {
    await this.configurePaymentMethods();
    this.getInterIntegrationConfig();
    this.getBillingPortifolios();
  }

  private getBillingPortifolios(): void {
    this.financesService.getAllBilingPortifolio().subscribe({
      next: (data) => {
        this.billingPortifolioDropdown = (data || []).map((wallet) => ({
          label: wallet.nome,
          value: wallet.idCarteiraCobranca,
        }));
      },
      error: () => {
        this.messageUtil.generateMessage('warning', 'Atenção', 'Erro ao carregar carteiras de cobrança');
      }
    });
  }

  private getInterIntegrationConfig() {
    this.bankPluginConfigService.getConfig(this.ITAU_BANK_CODE).subscribe({
      next: (resp) => {
        if(resp) {
          this.interIntegrationConfig = resp;
          this.selectedPaymentMethods(resp.paymentMethod);
          this.interIntegrationConfig.account = resp.account;
          this.keyPath = resp.keyUrl != null && resp.keyUrl != "";
          this.crtPath = resp.crtUrl != null && resp.crtUrl != "";
        }
      },
      error: (err) => {
        this.messageUtil.generateMessage('warning', 'Atenção', 'Erro ao consultar banco de dados');
      }
    });
  }

  save() {
    const config = this.interIntegrationConfig;
    const crt = this.crtPreview;
    const key = this.keyPreview;

    const account = this.accountDropdown.find(x => x.value === config.account);
    const paymentMethod = this.paymentMethodsDropdown.find(x => x.value === config.paymentMethod);

    config.accountName = account.label;
    config.paymentMethodName = paymentMethod.label;

    if(config.id == null || config.crtUrl == undefined || config.crtUrl == "") {
      if(!crt || crt[0] == null || crt[0] == undefined) {
        this.messageUtil.generateMessage('warning', 'Atenção', 'Arquivo .pem é obrigatório');
        return;
      }
    }

    if(config.id == null || config.keyUrl == undefined || config.keyUrl == "") {
      if(!key || key[0] == null || key[0] == undefined) {
        this.messageUtil.generateMessage('warning', 'Atenção', 'Arquivo .key é obrigatório');
        return;
      }
    }
    this.spinner.show();
    this.bankPluginConfigService.saveConfig(config, crt, key).subscribe({
      next: (resp) => {
        this.messageUtil.generateMessage('success', 'Sucesso', 'Configuração salva com sucesso');
        this.interIntegrationConfig = resp;
        this.crtPreview = undefined;
        this.keyPreview = undefined;
        this.spinner.hide();
      },
      error: (err) => {
        const exception = err?.error?.data?.exception;
        if (exception) {
          this.messageUtil.generateMessage(exception.type, exception.title, exception.message);
        } else {
          this.messageUtil.generateMessage('warning', 'Atenção', 'Erro ao salvar configuração');
        }
        this.spinner.hide();
      }
    });
  }

  // async configurePaymentMethods(): Promise<void> {
  //   const data = await this.getPaymentMethods();
  //   this.paymentMethods = data
  //       .filter((method) => method.contas.length !== 0)
  //       .map((method) => ({ method }));
  //   this.paymentMethodsDropdown = data
  //       .filter((method) => method.contas.length !== 0)
  //       .map((method) => ({
  //         label: method.descricao,
  //         value: method.idTipoFormaPagamento,
  //       }));
  //   this.accountDropdown = this.paymentMethods
  //       .filter((m) => !m.company)[0]
  //       .method.contas.map((account) => ({
  //         label: account.nome,
  //         value: account.idConta,
  //       }));
  //   this.accounts = this.paymentMethods
  //       .filter((m) => !m.company)[0]
  //       .method.contas;
  // }

  async getPaymentMethods(): Promise<TipoFormaPagamento[]> {
    return new Promise<TipoFormaPagamento[]>(async (res) => {
      //this.spinner.show();
      this.financesService.findTipoFormasPagamento().subscribe(
          async (data) => {
            res(data);
          },
          async (error) => {
            //  this.spinner.hide();
            const exception = error.error.data.exception;
            this.messageUtil.generateMessage(
                exception.type,
                exception.title,
                exception.message
            );
            res([]);
          }
      );
    });
  }

  setFileCrt(file: any) {
    this.uploadCrt.clear();
    this.crtPreview = file;
    const reader = new FileReader();
    reader.readAsDataURL(file[0]);
    reader.onload = (evt) => {
      // this.crtPreview = reader.result;
      this.crtPath = true;
    };
  }

  setFileKey(file: any) {
    this.uploadKey.clear();
    this.keyPreview = file;
    const reader = new FileReader();
    reader.readAsDataURL(file[0]);
    reader.onload = (evt) => {
      // this.keyPreview = reader.result;
      this.keyPath = true;
    };
  }

  getCheckIcon(isCrt = false) {
    const flag = isCrt ? this.crtPath : this.keyPath;
    return flag ? "pi pi-check mr-2 ml-2" : "pi pi-times mr-2 ml-2";
  }

  getWebhookIcon() {
    return this.interIntegrationConfig.webhookRegistered ? "pi pi-check mr-2 ml-2" : "pi pi-times mr-2 ml-2";
  }

  async selectedPaymentMethods(value): Promise<void> {
    return new Promise<void>(async (res) => {
      this.accountDropdown = this.paymentMethods
          .filter((m) => m.method.idTipoFormaPagamento === value && !m.company)[0]
          .method.contas.map((account) => ({
            label: account.nome,
            value: account.idConta,
          }));
      res();
    });
  }

  async configurePaymentMethods(): Promise<void> {

    const data = await this.getPaymentMethods();
    this.paymentMethods = data
        .filter((method) => method.contas.length !== 0 && method.tipo.id == 1)
        .map((method) => ({ method }));
    this.paymentMethodsDropdown = data
        .filter((method) => method.contas.length !== 0 && method.tipo.id == 1)
        .map((method) => ({
          label: method.descricao,
          value: method.idTipoFormaPagamento,
        }));
  }
}
